var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrespondence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.06875 20.75L0.5 25.125V2C0.5 1.66848 0.631696 1.35054 0.866116 1.11612C1.10054 0.881696 1.41848 0.75 1.75 0.75H24.25C24.5815 0.75 24.8995 0.881696 25.1339 1.11612C25.3683 1.35054 25.5 1.66848 25.5 2V19.5C25.5 19.8315 25.3683 20.1495 25.1339 20.3839C24.8995 20.6183 24.5815 20.75 24.25 20.75H6.06875ZM6.75 9.5V12H9.25V9.5H6.75ZM11.75 9.5V12H14.25V9.5H11.75ZM16.75 9.5V12H19.25V9.5H16.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrespondence);
export default __webpack_public_path__ + "static/media/Correspondence.d136892701dde32f7a8414824929c522.svg";
export { ForwardRef as ReactComponent };